<template>
  <div class="columns skeleton">
    <div class="column is-half is-offset-one-quarter">
      <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
      <br />
      <article class="media">
        <figure class="media-left">
          <p class="image is-64x64">
            <b-skeleton circle width="64px" height="64px"></b-skeleton>
          </p>
        </figure>
        <div class="media-content">
          <div class="content">
            <p>
              {{ loadingText }}<br />
              <b-skeleton active></b-skeleton>
              <b-skeleton height="80px"></b-skeleton>
            </p>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { BSkeleton } from "buefy"

export default defineComponent({
  name: "LoadingSkeleton",
  components: {
    BSkeleton,
  },
  props: {
    loadingText: {
      type: String,
      required: true,
    },
  },
})
</script>

<style lang="scss">
@import "@/styles/variables";
.skeleton {
  color: $ofb-vert-2;
  font-family: $font-family-title;
}
</style>
